export enum NeutralTypeEnum {
  danger = 'danger',
  blue = 'blue',
}
